/* eslint-disable react/prop-types */
// import { PropTypes } from "prop-types";

import React, { useContext, useEffect, useState } from "react";
import { graphql, Link, StaticQuery } from "gatsby";
import PropTypes from "prop-types";
import { DocumentContext } from "~context/DocumentContext";
import { AppContext } from "~context/AppContext";
import Button from "~components/Button";
import GradientBorder from "~components/GradientBorder";
import { getProductImage } from "~utils/shopify";

const query = graphql`
  query BrandShelf {
    allSanityProduct {
      edges {
        node {
          title
          handle
          image {
            asset {
              fluid {
                ...GatsbySanityImageFluid_noBase64
              }
            }
            altText
          }

          brands {
            title
          }

          collections {
            title
            handle
          }

          shopifyProduct {
            id
            title
            description
            handle
            images {
              originalSrc
            }
            productType
            vendor
            variants {
              id
              title
              image {
                originalSrc
              }
              price
              presentmentPrices {
                edges {
                  node {
                    price {
                      amount
                      currencyCode
                    }
                  }
                }
              }
              selectedOptions {
                name
                value
              }
            }
          }
        }
      }
    }
  }
`;

const BrandShelf = ({ className, brand, noBorder }) => {
  const { addToCart, inventoryCache, inventoryFetched } = useContext(
    AppContext
  );
  const { device } = useContext(DocumentContext);

  const [soldOutVariants, setSoldOutVariants] = useState([]);

  /**
   * ---------------------------------------------------------------------------
   * useEffect [inventoryCache]
   * Reads the inventoryCache for live stock availability
   * TODO : as module?
   */

  useEffect(() => {
    if (!inventoryCache) {
      return;
    }

    const unstockedVariants = [];

    Object.keys(inventoryCache).forEach(variantId => {
      if (
        inventoryCache[variantId] !== null &&
        inventoryCache[variantId] <= 0
      ) {
        unstockedVariants.push(variantId);
      }
    });

    setSoldOutVariants(unstockedVariants);
  }, [inventoryCache]);

  //

  return (
    <StaticQuery
      query={query}
      render={data => {
        const products = [];

        data.allSanityProduct.edges.forEach(({ node }) => {
          node.brands.forEach(productBrand => {
            if (
              productBrand?.title &&
              brand.title &&
              productBrand.title === brand.title
            ) {
              if (!brand) {
                brand = productBrand;
              }

              if (products.length < 4) {
                products.push(node);
              }
            }
          });
        });

        //

        return (
          <section
            className={`product-grid ${className} w-full relative bg-bone text-black`}
          >
            <div className="grid">
              <header
                className={`animation-appear-down-slow animation-delay-1 grid-end-12 md:grid-end-8 md:grid-start-3 relative ${
                  device === `desktop` ? `pt-v4` : `pt-8 pb-4`
                } flex flex-col items-center justify-center text-center`}
              >
                <h2 className="f2">{brand.title}</h2>

                <h3
                  className={`${
                    device === `desktop`
                      ? `mt-v1 mb-v2 h2`
                      : `mt-4 mb-6 px-12 b2`
                  }`}
                >
                  {brand.tagline || brand.description || ``}
                </h3>

                <Link to={`/brands/${brand.handle}`}>
                  <Button color="white">
                    <span className="block f-button pr-10 pl-10">
                      Shop brand
                    </span>
                  </Button>
                </Link>
              </header>
            </div>

            <ul
              className={`animation-appear-right-slow animation-delay-4 grid items-stretch ${
                device === `desktop` ? `pt-v4 pb-v2` : `pb-12`
              }`}
            >
              {products?.[0] &&
                products.map((product, productIndex) => {
                  const visible = true;

                  if (!visible) {
                    return <div key={product.handle} className="hidden"></div>;
                  }

                  const key = `${product.handle}-${productIndex}`;
                  const soldOut = soldOutVariants?.includes(
                    product?.shopifyProduct?.variants?.[0]?.id
                  );

                  //

                  return (
                    <li
                      key={key}
                      className={`product-grid__item grid-end-6 md:grid-end-3 relative flex flex-col items-stretch ${
                        device === `desktop`
                          ? `mb-v4 pr-v05 pl-v05`
                          : `mt-3 mb-5 ${
                              productIndex % 2 === 0 ? `pr-1` : `pl-1`
                            }`
                      }`}
                    >
                      <Link
                        to={`/products/${product.handle}`}
                        className="product-grid__item__image relative overflow-hidden bg-light-bone"
                      >
                        <figure className="w-full h-full absolute top-0 right-0 bottom-0 left-0 flex items-center justify-center">
                          {getProductImage(product)}
                        </figure>
                      </Link>

                      <Link
                        to={`/products/${product.handle}`}
                        className="product-grid__item__text relative"
                      >
                        <h2
                          className={`hover-underline ${
                            device === `desktop` ? `mt-v1` : `mt-4`
                          } b2 italic`}
                        >
                          {product.title}
                        </h2>

                        {product?.brands?.[0]?.title && (
                          <h3
                            className={`${
                              device === `desktop` ? `` : `mb-2`
                            } b2`}
                          >
                            {product.brands[0].title}
                          </h3>
                        )}

                        {product?.shopifyProduct?.variants?.[0] && (
                          <p className="b2">
                            ${product.shopifyProduct.variants[0].price}
                          </p>
                        )}
                      </Link>

                      <div className="w-full relative flex md:block mt-v1">
                        {device !== `desktop` && (
                          <Link
                            to={`/products/${product.handle}`}
                            className={`${
                              product?.shopifyProduct?.variants?.[0]
                                ? `w-1/2`
                                : `w-full`
                            } relative block mr-1`}
                          >
                            <Button
                              className="w-full relative block"
                              color="white"
                            >
                              <span className="block caption">View</span>
                            </Button>
                          </Link>
                        )}

                        {(product?.shopifyProduct?.variants?.[0] && (
                          <Button
                            className={`w-1/2 md:w-full relative block ${
                              soldOut ? `opacity-25 pointer-events-none` : ``
                            } ml-1 md:ml-0`}
                            color={`${
                              device === `desktop` ? `white` : `orange`
                            }`}
                            onClick={() => {
                              if (!soldOut) {
                                addToCart({
                                  ...product,
                                  variant: product.shopifyProduct.variants[0]
                                });
                              }
                            }}
                          >
                            {(device === `desktop` && (
                              <span className="block f-button">
                                {soldOut ? `Sold out` : `Add to cart`}
                              </span>
                            )) || (
                              <span className="block caption">
                                {soldOut ? `Sold out` : `Add`}
                              </span>
                            )}
                          </Button>
                        )) || (
                          <Button
                            className="w-full relative block opacity-25 pointer-events-none"
                            color="white"
                          >
                            <span className="f-button">
                              {device === `desktop` ? `Currently ` : ``}
                              Unavailable
                            </span>
                          </Button>
                        )}
                      </div>
                    </li>
                  );
                })}
            </ul>

            {!noBorder && <GradientBorder />}
          </section>
        );
      }}
    />
  );
};

BrandShelf.defaultProps = {
  className: ``,
  noBorder: false
};

BrandShelf.propTypes = {
  className: PropTypes.string,
  noBorder: PropTypes.bool
};

export default BrandShelf;
